"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportIntegralProductTemplateApi = exportIntegralProductTemplateApi;
exports.shopIntegralActivityDeleteApi = shopIntegralActivityDeleteApi;
exports.shopIntegralActivityEndApi = shopIntegralActivityEndApi;
exports.shopIntegralActivityInfoApi = shopIntegralActivityInfoApi;
exports.shopIntegralActivityPageApi = shopIntegralActivityPageApi;
exports.shopIntegralActivityProductCancelImportBatchApi = shopIntegralActivityProductCancelImportBatchApi;
exports.shopIntegralActivityProductDeleteByIdApi = shopIntegralActivityProductDeleteByIdApi;
exports.shopIntegralActivityProductImportApi = shopIntegralActivityProductImportApi;
exports.shopIntegralActivityProductPageApi = shopIntegralActivityProductPageApi;
exports.shopIntegralActivityProductSubmitImportBatchApi = shopIntegralActivityProductSubmitImportBatchApi;
exports.shopIntegralActivityProductUpdateMallStatusApi = shopIntegralActivityProductUpdateMallStatusApi;
exports.shopIntegralAddExchangeActivityApi = shopIntegralAddExchangeActivityApi;
exports.shopIntegralAddGiveActivityApi = shopIntegralAddGiveActivityApi;
exports.shopIntegralGiveActivityInfoApi = shopIntegralGiveActivityInfoApi;
exports.shopIntegralIntegralConfigApi = shopIntegralIntegralConfigApi;
exports.shopIntegralIntegralGetConfigApi = shopIntegralIntegralGetConfigApi;
exports.shopIntegralOrderListApi = shopIntegralOrderListApi;
exports.shopIntegralUpdateExchangeActivityApi = shopIntegralUpdateExchangeActivityApi;
exports.shopIntegralUpdateGiveActivityApi = shopIntegralUpdateGiveActivityApi;
exports.shopIntegralUserIntegralDetailPageApi = shopIntegralUserIntegralDetailPageApi;
exports.shopIntegralUserIntegralDetailStatApi = shopIntegralUserIntegralDetailStatApi;
exports.shopIntegralUserIntegralPageApi = shopIntegralUserIntegralPageApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 积分活动分页
 * POST query: page、limit
 * Body: ShopIntegralActivitySearchRequest（与后端字段一致，不再包一层 request）
 * @param {{ page: number, limit: number }} params 分页 query
 * @param {Object} body activityType、activityName、status 等
 */
function shopIntegralActivityPageApi(params, body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/page',
    method: 'post',
    params: {
      page: params.page,
      limit: params.limit
    },
    data: body || {}
  });
}

/**
 * 活动详情（编辑/复制回显）
 * GET query: id
 */
function shopIntegralActivityInfoApi(id) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/info',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 兑换积分活动详情（编辑/复制回显）
 * GET query: id，返回 ShopIntegralGiveActivitySaveRequest 结构
 */
function shopIntegralGiveActivityInfoApi(id) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/giveInfo',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 结束活动
 * GET query: id
 */
function shopIntegralActivityEndApi(id) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/end',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 删除活动
 * GET query: id
 */
function shopIntegralActivityDeleteApi(id) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/delete',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 新增兑换积分活动
 * POST Body: ShopIntegralActivitySaveRequest（不传 id，不再包一层 request）
 */
function shopIntegralAddExchangeActivityApi(body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/addExchangeActivity',
    method: 'post',
    data: body || {}
  });
}

/**
 * 编辑兑换积分活动
 * POST Body: ShopIntegralActivitySaveRequest（须带 id，不再包一层 request）
 */
function shopIntegralUpdateExchangeActivityApi(body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/updateExchangeActivity',
    method: 'post',
    data: body || {}
  });
}

/**
 * 新增返积分活动
 * POST Body: activityName、startTime、endTime、productType、rules[]；用卡规则 costType=2 时传 cardIds（数组）与 givePercent
 */
function shopIntegralAddGiveActivityApi(body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/addGiveActivity',
    method: 'post',
    data: body || {}
  });
}

/**
 * 编辑兑换积分活动
 * POST Body: 同新增，须带 id
 */
function shopIntegralUpdateGiveActivityApi(body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/updateGiveActivity',
    method: 'post',
    data: body || {}
  });
}

/**
 * 积分系统配置查询
 * GET 无参数，返回积分到账、退款、商城展示范围、有效期及规则文案配置
 */
function shopIntegralIntegralGetConfigApi() {
  return (0, _request.default)({
    url: '/admin/shopintegral/integral/getConfig',
    method: 'get'
  });
}

/**
 * 积分系统配置保存
 * POST Body：积分到账、退款、商城展示范围、有效期及规则文案配置
 */
function shopIntegralIntegralConfigApi(body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/integral/config',
    method: 'post',
    data: body || {}
  });
}

/**
 * 活动商品 Excel 导入
 * POST multipart：file、activityId、activityType；非首次导入需带 batchId
 * @param {{ activityId: number|string, activityType: number, file: File, batchId?: number|string }} payload
 * @returns Promise<{{ batchId: number, repeatSkuIds?: array, repeats?: array }}> 拦截器已解包为 data；repeatSkuIds / repeats 有值表示与现有商品 SKU 重复
 */
function shopIntegralActivityProductImportApi(payload) {
  var activityId = payload.activityId,
    activityType = payload.activityType,
    file = payload.file,
    batchId = payload.batchId;
  var formData = new FormData();
  formData.append('file', file);
  formData.append('activityId', activityId);
  formData.append('activityType', activityType);
  if (batchId != null && batchId !== '') {
    formData.append('batchId', batchId);
  }
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/product/importActivityProduct',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    __skipGlobalErrorMessage: true
  });
}

/** 导入模板 GET ?fileName= */
function exportIntegralProductTemplateApi(fileName) {
  return (0, _request.default)({
    url: '/admin/export/excel/template',
    method: 'get',
    params: {
      fileName: fileName
    }
  });
}

/**
 * 活动商品分页
 * POST query：page、limit；Body：activityId、activityType 必填，batchId 等与检索条件选填；排序 sortField（updateTime|retailPrice|costPrice|supplyPrice|defaultPrice；activityType=2 时可传 showSellPrice）、sortType（asc|desc）
 */
function shopIntegralActivityProductPageApi(params, body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/product/page',
    method: 'post',
    params: {
      page: params.page,
      limit: params.limit
    },
    data: body || {}
  });
}

/**
 * 活动商品删除（按主键）
 * GET query：id 必填；batchId 选填（导入批次场景）
 * @param {{ id: number|string, batchId?: number|string }} params
 */
function shopIntegralActivityProductDeleteByIdApi(params) {
  var query = {
    id: params.id
  };
  if (params.batchId != null && params.batchId !== '') {
    query.batchId = params.batchId;
  }
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/product/deleteById',
    method: 'get',
    params: query
  });
}

/**
 * 活动商品上下架
 * GET query：id、mallStatus 必填（0 下架 1 上架）；batchId 选填
 */
function shopIntegralActivityProductUpdateMallStatusApi(params) {
  var query = {
    id: Number(params.id),
    mallStatus: Number(params.mallStatus)
  };
  if (params.batchId != null && params.batchId !== '') {
    query.batchId = Number(params.batchId);
  }
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/product/updateMallStatus',
    method: 'get',
    params: query
  });
}

/**
 * 提交活动商品导入批次（确认批次）
 * GET query：activityId、activityType、batchId（与导入接口返回的 batchId 一致；均为 number）
 */
function shopIntegralActivityProductSubmitImportBatchApi(body) {
  var b = body || {};
  var params = {
    activityId: Number(b.activityId),
    activityType: Number(b.activityType)
  };
  if (b.batchId != null && b.batchId !== '') {
    params.batchId = Number(b.batchId);
  }
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/product/submitImportBatch',
    method: 'get',
    params: params
  });
}

/**
 * 取消活动商品导入批次
 * GET query：activityId、activityType、batchId（与导入返回 batchId 一致）
 */
function shopIntegralActivityProductCancelImportBatchApi(params) {
  var p = params || {};
  var query = {
    activityId: Number(p.activityId),
    activityType: Number(p.activityType),
    batchId: Number(p.batchId)
  };
  return (0, _request.default)({
    url: '/admin/shopintegral/activity/product/cancelImportBatch',
    method: 'get',
    params: query
  });
}

/**
 * 用户积分分页
 * GET query：page、limit、keyword（用户ID/姓名/手机号模糊）、customerId（来源客户ID），均可选
 */
function shopIntegralUserIntegralPageApi(params) {
  var p = {
    page: Number(params.page) || 1,
    limit: Number(params.limit) || 10
  };
  if (params.keyword != null && String(params.keyword).trim() !== '') {
    p.keyword = String(params.keyword).trim();
  }
  if (params.customerId != null && params.customerId !== '') {
    p.customerId = Number(params.customerId);
  }
  return (0, _request.default)({
    url: '/admin/shopintegral/userIntegral/page',
    method: 'get',
    params: p
  });
}

/**
 * 用户积分明细统计（抽屉顶部汇总）
 * GET query：customerId、userPhone 必填
 */
function shopIntegralUserIntegralDetailStatApi(params) {
  return (0, _request.default)({
    url: '/admin/shopintegral/userIntegral/detailStat',
    method: 'get',
    params: {
      customerId: Number(params.customerId),
      userPhone: String(params.userPhone || '').trim()
    }
  });
}

/**
 * 用户积分明细分页
 * GET query：customerId、userPhone 必填；page、limit、serialNo、startTime、endTime、changeType 可选
 */
function shopIntegralUserIntegralDetailPageApi(params) {
  var p = {
    customerId: Number(params.customerId),
    userPhone: String(params.userPhone || '').trim(),
    page: Number(params.page) || 1,
    limit: Number(params.limit) || 10
  };
  if (params.serialNo != null && String(params.serialNo).trim() !== '') {
    p.serialNo = String(params.serialNo).trim();
  }
  if (params.startTime) {
    p.startTime = params.startTime;
  }
  if (params.endTime) {
    p.endTime = params.endTime;
  }
  if (params.changeType != null && params.changeType !== '') {
    p.changeType = Number(params.changeType);
  }
  return (0, _request.default)({
    url: '/admin/shopintegral/userIntegral/detailPage',
    method: 'get',
    params: p
  });
}

/**
 * 积分订单分页列表
 * POST query：page、limit
 * body：keyword（订单号/产品名称/手机号）、orderType（1 自营 2 虚拟卡券 3 优惠券商品）、status（订单状态，整型）
 */
function shopIntegralOrderListApi(params, body) {
  return (0, _request.default)({
    url: '/admin/shopintegral/order/list',
    method: 'post',
    params: {
      page: params.page,
      limit: params.limit
    },
    data: body || {}
  });
}